var map = {
	"./add-to-cart.svg": 17292,
	"./arrow-down.svg": 6761,
	"./arrow-left.svg": 69461,
	"./arrow-right.svg": 48706,
	"./book.svg": 94736,
	"./brush.svg": 50158,
	"./calendar.svg": 29864,
	"./cart.svg": 4409,
	"./circle.svg": 98894,
	"./close.svg": 13012,
	"./delivery.svg": 35644,
	"./earth.svg": 91643,
	"./eco.svg": 29011,
	"./facebook.svg": 98507,
	"./gift.svg": 67988,
	"./hamburger.svg": 11771,
	"./help.svg": 74378,
	"./instagram.svg": 59239,
	"./jupiter.svg": 25817,
	"./loading.svg": 85478,
	"./mars.svg": 36973,
	"./menu.svg": 85638,
	"./mercury.svg": 54320,
	"./minus.svg": 49092,
	"./neptune.svg": 92638,
	"./palette.svg": 40475,
	"./paper.svg": 20782,
	"./pen.svg": 54898,
	"./planet.svg": 42554,
	"./plus-minus.svg": 9906,
	"./plus.svg": 54993,
	"./quotation-mark.svg": 79947,
	"./ruler.svg": 91061,
	"./saturn.svg": 37271,
	"./shipping.svg": 88342,
	"./star.svg": 99213,
	"./sun.svg": 76608,
	"./triangle.svg": 81316,
	"./twitter.svg": 93543,
	"./uranus.svg": 45734,
	"./venus.svg": 70900,
	"./wallpaper.svg": 61605,
	"./zoom.svg": 22822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92188;